import Vue from 'vue';
import MyPage from './Page';
import { THS } from './constant';
import store from '@/store/index';
//@ts-ignore
let state = store.state.card;
export abstract class BaseSubject {
  submitDisabled: boolean = false;
  /**
   * 答题卡页面对象
   */
  page: MyPage = new MyPage();
  /**
   * 题目名称
   */
  name: any = '';

  /**
   * 题目类型 type
   * 1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题, 7 表示非作答区域
   *
   * */
  type: any;

  /**
   * 题号
   */
  th: string = '';
  historyTH: string = '';
  /**
   * 题目列表
   */
  items: { no: any; value?: any; score?: any; xth?: string; lineNum?: any; }[] = [];

  /**
   * 起始题号
   */
  start?: any;

  score?: any;
  totalScore?: number = 0;

  value?: any;
  /**
   * 结束题号
   */
  end?: any;

  id?: string;

  innerHTML: any;
  boxs: any[] = [];
  rows: string[] = [];
  htmlArray: string[] = [];
  initDragHeight: number = 0;
  fromEdit: boolean = false; // 判断是否来自编辑的实例化
  editName: string | undefined = undefined; // 存储用户手动输入的题型名称
  constructor(obj?: {
    name?: string;
    start?: any;
    end?: any;
    score?: any;
    value?: any;
    th?: any;
    historyTH?: any;
    items?: any[];
    innerHTML?: string;
    boxs?: [];
  }) {
    if (typeof obj == 'string') {
      obj = { name: obj };
    }
    this.page = new MyPage(obj);
    obj = obj || {};
    this.name = obj.name;
    this.th = obj.th || state && state.THS[0];
    this.historyTH = obj.historyTH;
    this.start = obj.start || 1;
    this.end = obj.end || 2;
    this.score = obj.score || 2;
    this.value = Number(obj.value) || 1;
    if (obj.innerHTML) {
      !this.innerHTML && (this.innerHTML = obj.innerHTML);
    }
    if (obj.items && obj.items.length) {
      this.items = obj.items;
    }
    this.id = `${this.th}_${this.name}`;
  }

  // 追加
  addItems(obj: any) {
    for (let idx = Number(obj.start); idx <= Number(obj.end); idx++) {
      obj.items &&
        this.items.push({
          no: idx,
          score: obj.score,
          value: obj.score, // 保留字段
          lineNum: obj.lineNum,
        });
    }
    const hash: any = {};
    this.items = this.items.reduce((item: any, next: any) => {
      hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
      return item;
    }, []); // 对象数组去重
    this.items.sort((a: any, b: any) => {
      return a.no - b.no;
    });
  }

  // 新建
  createItems(obj: any) {
    this.items = [];
    for (let idx = obj.start; idx <= obj.end; idx++) {
      obj.items &&
        this.items.push({
          no: idx,
          score: obj.score,
          value: obj.score, // 保留字段
          lineNum: obj.lineNum,
        });
    }
    const hash: any = {};
    this.items = this.items.reduce((item: any, next: any) => {
      hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
      return item;
    }, []); // 对象数组去重
    this.items.sort((a: any, b: any) => {
      return a.no - b.no;
    });
  }

  abstract render(options?: any): void;

  abstract appendToPage(state: any, pageHeight: number, newTopicHeight?: number): void;

  onDragged() {}

  setInitDragHeight(initDragHeight: number): void {
    this.initDragHeight = initDragHeight;
  }

  setHtml(html: string): void {
    this.innerHTML = html;
  }
  setHtmlArray(htmlArray: Array<any>): void {
    this.htmlArray = htmlArray;
  }
  setStart(start: number): void {
    this.start = start;
  }
  setEnd(end: number): void {
    this.end = end;
  }
  setFromEdit(fromEdit: boolean): void {
    this.fromEdit = fromEdit;
    // 1s之后将fromEdit设置为false 为了不保存到付服务器
    const timer = setTimeout(() => {
      this.fromEdit = false;
      clearTimeout(timer);
    }, 1000);
  }

  setEditName(editName: string | undefined): void {
    this.editName = editName;
  }
}
